import { createFileRoute, redirect } from "@tanstack/react-router";
import { getDefaultTraining } from "#/lib/training";

// Kept for backward compatibility with old shared/indexed links — the real
// page is now /brochure/$slug (see src/routes/brochure/$slug.tsx), generalized
// so each training gets its own brochure instead of one hardcoded page.
export const Route = createFileRoute("/brochure-complet")({
	beforeLoad: async () => {
		const training = await getDefaultTraining();
		throw redirect({ to: "/brochure/$slug", params: { slug: training.slug } });
	},
});
